// Copyright 2025 Held Solutions LLC

import React, { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './auth';
import './App.css';
import './SidebarNav.css'; // Import the new CSS file
import SidebarCanvas from './SidebarCanvas'; // Import the new SidebarCanvas component

import { sidebarStructure } from './sidebarStructure';

function PTCLogo() {
  return (
    <NavLink className="sidebar-logo" to="/" end>
      <img
        src="https://storage.googleapis.com/heldsolutionsllc-public-bucket/icons/ptc/ptc_logo_large_transparent.png"
        alt="PTC Logo"
        className="sidebar-logo-img"
      />
    </NavLink>
  );
}

function SidebarNav({ sidebarOpen, setSidebarOpen, onClose, handleStartTour }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [openSections, setOpenSections] = useState({});

  const updateSidebarOpeningsBasedOnLocation = () => {
    const updateOpenSections = (path, structure, parentKey = '') => {
      Object.entries(structure).forEach(([key, item]) => {
        const sectionKey = parentKey ? `${parentKey}.${key}` : key;
        if (item.route === path) {
          setOpenSections((prev) => ({ ...prev, [sectionKey]: true }));
          const ancestors = parentKey.split('.').reduce((acc, part, index) => {
            const ancestorKey = acc.length ? `${acc[index - 1]}.${part}` : part;
            acc.push(ancestorKey);
            return acc;
          }, []);
          ancestors.forEach((ancestor) => {
            setOpenSections((prev) => ({ ...prev, [ancestor]: true }));
          });
        }
        if (item.children) {
          updateOpenSections(path, item.children, sectionKey);
        }
      });
    };

    updateOpenSections(location.pathname, sidebarStructure.home.children);
  };

  React.useEffect(updateSidebarOpeningsBasedOnLocation, [location.pathname]);

  const toggleSection = (key) => {
    setOpenSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const renderSidebarItems = (items, parentKey = '') => {
    return Object.entries(items).map(([key, item]) => {
      const route = item.route || (item.children && Object.values(item.children)[0]?.route);
      const title = item.title;
      const sectionKey = parentKey ? `${parentKey}.${key}` : key;

      if (item.hideIfAuthenticated && user) return null;
      if (item.hideIfNotAuthenticated && !user) return null;

      if (key === 'tour') {
        return (
          <div
            key={key}
            className={`sidebar-link sidebar-link-${key}`}
            onClick={() => {
              // setSidebarOpen(false);
              handleStartTour();
            }}
          >
            {title}
          </div>
        );
      }

      if (item.children) {
        const isOpen = openSections[sectionKey] || false;

        return (
          <div key={key} className={`sidebar-dropdown sidebar-dropdown-${key}`}>
            <div
              className="sidebar-dropdown-header"
              onClick={() => {
                if (item.redirectToFirstChild && !openSections[sectionKey] && route) {
                  navigate(route);
                  // setSidebarOpen(false);
                }
                toggleSection(sectionKey);
              }}
            >
              {title}
              <span className={`chevron ${isOpen ? 'open' : ''}`}>▼</span>
            </div>
            {isOpen && (
              <div className="sidebar-nested">
                {renderSidebarItems(item.children, sectionKey)}
              </div>
            )}
          </div>
        );
      }

      return (
        <div
          key={key}
          className={`sidebar-link sidebar-link-${key}`}
          onClick={() => {
            navigate(route);
            // setSidebarOpen(false);
          }}
        >
          {title}
        </div>
      );
    });
  };

  return (
    <>
      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>}

      <div className={`sidebar-drawer${sidebarOpen ? ' open' : ''}`}>
        <button
          className="sidebar-toggle-btn"
          onClick={() => setSidebarOpen(!sidebarOpen)} // Toggle sidebar state
        >
          ☰
        </button>

        <div className="sidebar" style={{ position: 'relative', background: 'transparent' }}>
          {/* <SidebarCanvas /> */}
          
          <PTCLogo />
          <div className="client-nav">
            {renderSidebarItems(sidebarStructure.home.children)}
          </div>

          <div className="sidebar-footer" style={{ fontSize: '12px', color: '#888', textAlign: 'center', marginTop: '20px' }}>
            © 2025 Held Solutions LLC
          </div>
        </div>
      </div>
    </>
  );
}

export default SidebarNav;
